const initialState = {
  alarmNotiTriggerKey: 0,
  selectedAlarmNotification: {
    id: null,
    desc: null,
  },
};

export default function alarmNotificationActions(state = initialState, action) {
  switch (action.type) {
    case "TRIGGER_ALARM_NOTIFICATION_EFFECT":
      return { ...state, alarmNotiTriggerKey: state.alarmNotiTriggerKey + 1 };
    case "UPDATE_SELECTED_ALARM_NOTIFICATION":
      return {
        ...state,
        selectedAlarmNotification: {
          ...state.selectedAlarmNotification,
          ...action.payload,
        },
        alarmNotiTriggerKey: state.alarmNotiTriggerKey + 1,
      };

    case "CLEAR_SELECTED_ALARM_NOTIFICATION":
      return {
        ...state,
        selectedAlarmNotification: { id: null, desc: null },
        alarmNotiTriggerKey: state.alarmNotiTriggerKey + 1,
      };

    default:
      return state;
  }
}

